module.exports = __webpack_public_path__ + "static/media/10.c6952fd7.jpg";